/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ReportButton_viewer = {
    readonly id: string;
    readonly " $refType": "ReportButton_viewer";
};
export type ReportButton_viewer$data = ReportButton_viewer;
export type ReportButton_viewer$key = {
    readonly " $data"?: ReportButton_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"ReportButton_viewer">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ReportButton_viewer",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
        }
    ],
    "type": "User",
    "abstractKey": null
} as any);
(node as any).hash = '994d0997925beb3bca658b199558e090';
export default node;
